'use client';
import type React from 'react';
import { useCallback } from 'react';

import { ContentDto } from '@cineamo/api/models/content/ContentDto.types';

import PageLeaveTracker from '@cineamo/composables/src/PageLeaveTracker';

import { markAdClickAttributionAsSameSession } from './adClickAttribution';

const AdvertisementPageLeaveTracker: React.FC<{
    contentId: ContentDto['id'];
}> = ({ contentId }) => {
    const trackPageLeave = useCallback(() => {
        markAdClickAttributionAsSameSession(contentId);
    }, [contentId]);

    return <PageLeaveTracker onNavigate={trackPageLeave} />;
};

export default AdvertisementPageLeaveTracker;
